import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Ecranul "Customers" - `Easeedesk::customers`, tabelul `owners_licenses` si
 * cele doua butoane de licenta.
 */

export interface CustomersPage {
  ready: boolean
  company: number
}

/** `Owners_support::getActions`: ce se poate face cu licenta randului. */
export interface CustomerActions {
  add: number
  disabled: number
  edit: number
}

export interface CustomerRow {
  ID: number
  DT_RowId: string
  firstname: string | null
  lastname: string | null
  email: string | null
  phone: string | null
  mobile_phone: string | null
  vip: number | null
  create_date: string | null
  last_edit: string | null
  disabled: number | null
  by_date_range: number | null
  license_type_name: string | null
  start_license: string | null
  end_license: string | null
  actions: CustomerActions
}

export interface CustomersTable {
  draw: number
  recordsTotal: number
  recordsFiltered: number
  data: CustomerRow[]
}

export const customersPageQuery = queryOptions({
  queryKey: ['easeedesk', 'customers', 'page'],
  queryFn: () => apiGet<CustomersPage>('/easeedesk/customers'),
})

export function customersTableParams(r: {
  draw: number
  start: number
  length: number
  orderColumn: number
  orderDir: 'asc' | 'desc'
  search: string
}): URLSearchParams {
  const p = new URLSearchParams()
  p.set('draw', String(r.draw))
  p.set('start', String(r.start))
  p.set('length', String(r.length))
  p.set('order[0][column]', String(r.orderColumn))
  p.set('order[0][dir]', r.orderDir)
  p.set('search[value]', r.search)
  return p
}

export function customersTableQuery(r: {
  draw: number
  start: number
  length: number
  orderColumn: number
  orderDir: 'asc' | 'desc'
  search: string
}) {
  return queryOptions({
    queryKey: ['easeedesk', 'customers', 'table', r],
    queryFn: () => apiGet<CustomersTable>(`/easeedesk/customers/table?${customersTableParams(r).toString()}`),
  })
}

/** "Disable license" / "Enable license" - cele doua capete vechi, intr-unul. */
export function setCustomerLicense(owner: number, disabled: boolean): Promise<{ ok: boolean }> {
  return apiPost(`/easeedesk/customers/${owner}/license`, { disabled: disabled ? 1 : 0 })
}
